import React, { useState } from "react"
import { PictureOutlined } from "@ant-design/icons"
import strings from "utils/strings"

export const ImageAttachment: React.FC<{ url: string }> = ({ url }) => {
	const [errored, setErrored] = useState(false)

	if (errored) {
		return (
			<div className="msg-img-placeholder">
				<PictureOutlined />
				<span>{strings.messaging.imageUnavailable}</span>
			</div>
		)
	}

	return (
		<img
			src={url}
			className="msg-img"
			alt={strings.messaging.imageAlt}
			onError={() => setErrored(true)}
		/>
	)
}
